import { render } from "./sqlFileImportConfig.vue?vue&type=template&id=22293408&ts=true"
import script from "./sqlFileImportConfig.vue?vue&type=script&lang=ts"
export * from "./sqlFileImportConfig.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__